// aspect-type.js
class KeiDecrypt {

    constructor(initialString) {
        this.initialString = initialString;
    }

    calculateShift(key) {

        var nums = 0;
        var code = 0;

        for (var i = 0; i < key.length; i++) {
            code += key.charCodeAt(i);
            nums = Math.floor(code / 10)
        }

        var shifted_array = [];

        for (var numshifts = 0; numshifts < nums; numshifts++) {
            shifted_array = JSON.parse(JSON.stringify(settings.possible_words))
            var word = shifted_array.shift();
            shifted_array.push(word);
        }

        return shifted_array;

    }

    shuffle(key, elements){

        var steps = [];

        for(var i = 0; i < key.length; i++){
            var char = String(key.charCodeAt(i))

            for(var j = 0; j < char.length; j ++){
                if(char.charAt(j) > 8)continue;
                steps.push((char.charAt(j)))
            }
        }


        for(var i = 0; i < (steps.length-1); i++){
            var from = steps[i]
            var to = steps[i+1]


            var b = elements[from];
            elements[from] = elements[to];
            elements[to] = b;
        }


        return elements;
    }

    unshuffle(key, elements){

        var steps = [];


        for(var i = 0; i < key.length; i++){
            var char = String(key.charCodeAt(i))

            for(var j = 0; j < char.length; j ++){
                if(char.charAt(j) > 8)continue;
                steps.push((char.charAt(j)))
            }
        }

        steps = steps.reverse()


        for(var i = 0; i < (steps.length-1); i++){
            var from = steps[i]
            var to = steps[i+1]

            var b = elements[from];
            elements[from] = elements[to];
            elements[to] = b;
        }

        return elements;
    }

    getNumChars() {

        var wordArray = String(this.initialString).split(settings.endchar);
        wordArray.pop();

        return wordArray


    }

    decrypt(key) {
        var encodedCharArray = this.getNumChars()

        var shiftedArray = this.calculateShift(key)

        var out = ""

        //(encodedCharArray);

        for (var i = 0; i < encodedCharArray.length; i++) {
            var encodedChar = encodedCharArray[i].trim();

            var charArray = encodedChar.split(" ");


            charArray = this.unshuffle(key, charArray);


            var charArrayCopy = JSON.parse(JSON.stringify(charArray));



            for (var j = 0; j < charArrayCopy.length; j++) {
                var char = charArray[j];

                if (String(char) == ":b:️" || char === settings.eight_zeroes) {
                    console.log(char)

                    var zeroarr = ["cuh", "cuh", "cuh", "cuh", "cuh", "cuh", "cuh", "cuh"]

                    charArray.splice(j, 1, ...zeroarr);

                }
            }


            for (var j = 0; j < charArray.length; j++) {
                var char = charArray[j];

                if (settings.zerobits.indexOf(char) > -1) {
                    //Is zero
                    charArray[j] = "0";
                } else {

                    charArray[j] = "1";
                }

            }

            var finalBinary = charArray.join("");

            var digit = parseInt(finalBinary, 2);

            out += String.fromCharCode(digit)

        }

        return out;
    }
}

var settings = {
    endchar: "boxlunch",
    possible_words: [
        "salad",
        "💩",
        "slice",
        "optimal",
        "chicka",
        "boop",
        "1337",
        "guys",
        "soy",
        "sauce",
        "🧀",
        "lunch",
        "home",
        "bread",
        "👞",
        "suboptimal"
    ],
    shifted_array: [],
    zerobits: [
        "stuu",
        "fuu",
        "in",
        "the",
        "shinso",
        "wutong",
        "hoynoy",
        "cuh"
    ],
    startchar: "hoynoy",
    endchar: "boxlunch",
    eight_zeroes: "🅱️"
}

export default KeiDecrypt;